module.exports = __webpack_public_path__ + "static/img/lingdang.bff033c4.png";